import { FC, Fragment } from "react";

interface AttachedCellProps {
  data: boolean;
}

export const AttachedCell: FC<AttachedCellProps> = ({ data }) => {
  return <Fragment>{data ? "Attached" : "Unattached"}</Fragment>;
};
